import { Vector2} from 'three'

const FadeShader = {
  uniforms: {
    tDiffuse: { value: null },
    tMask: { value: null },
    opacity: { value: 1.0 },
    scale: { value: 0.0 },
    amount: { value: 0.0 },
    angle: { value: 0.0 },
    time: { value: 0.0 },
    resolution: { value: new Vector2( 1 / 1024, 1 / 512 ) }
  },

  vertexShader: `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
  }
`,

  fragmentShader: `
  varying vec2 vUv;
  uniform sampler2D tDiffuse;
  uniform sampler2D tMask;
    
  uniform float amount;
  uniform float angle;
  uniform float scale;
  uniform float opacity;
  
  uniform vec2 resolution; 
  uniform float time;    
  
  vec4 fade(sampler2D tex) {
    vec4 black = vec4(0.0,0.0,0.0, 1.0);
    vec4 color = texture2D(tex, vUv);
    return mix( color, black, amount); 
  }

  void main() {
      gl_FragColor = fade(tDiffuse);        
  }
`,
}

export { FadeShader }
